import { useMutation } from "react-query";
import http from "infra/http";
import { AnexoResponse } from 'core/features/arquivo/typings/index';

function useUploadArquivoCliente(id: string) {
  return useMutation(
    `/v1/cliente/${id}/arquivos`,
    async (file: File) =>
    {
      const form = new FormData();
      
      form.append('file', file);

      return await http.post<AnexoResponse>(
        `/v1/cliente/${id}/arquivos`, form
      )},
    { retry: false }
  );
}

export default useUploadArquivoCliente;
